import type { Movie } from "@/types";
import MovieCard from "@/components/feature/MovieCard";

interface RelatedMoviesProps {
  movies: Movie[];
}

export default function RelatedMovies({ movies }: RelatedMoviesProps) {
  if (movies.length === 0) return null;

  return (
    <div data-product-shop className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-4">
      {movies.map((movie) => (
        <MovieCard key={movie.id} movie={movie} />
      ))}
    </div>
  );
}